const LDO = ({ ...props }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M20 0H0V20H20V0Z" fill="url(#paint0_linear_3184_16658)" />
    <path d="M20 0H0V20H20V0Z" fill="url(#paint1_radial_3184_16658)" />
    <path
      d="M14.3315 9.14719L10.0003 11.6859L5.62793 9.20507L10.0003 6.77295L14.3315 9.14719Z"
      fill="url(#paint2_radial_3184_16658)"
    />
    <path
      d="M10.0002 11.6858L5.62785 9.20505C5.04304 10.0572 4.7002 11.0884 4.7002 12.2C4.7002 15.1271 7.07311 17.5 10.0002 17.5C12.9274 17.5 15.3003 15.1271 15.3003 12.2C15.3003 11.0629 14.941 10.0104 14.3315 9.14716L10.0002 11.6858V11.6858Z"
      fill="url(#paint3_radial_3184_16658)"
    />
    <path
      d="M10 2.5V10.3494L13.7377 8.22234L10 2.5Z"
      fill="url(#paint4_linear_3184_16658)"
    />
    <path
      d="M10 6.20825V10.3494L13.7377 8.22236L10 6.20825Z"
      fill="url(#paint5_linear_3184_16658)"
    />
    <path
      d="M10.0004 2.5V10.3494L6.2627 8.22234L10.0004 2.5Z"
      fill="url(#paint6_linear_3184_16658)"
    />
    <path
      d="M10.0004 6.20825V10.3494L6.2627 8.22236L10.0004 6.20825Z"
      fill="url(#paint7_linear_3184_16658)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3184_16658"
        x1="10"
        y1="19.3666"
        x2="10"
        y2="0.776641"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F3D3AA" />
        <stop offset="1" stop-color="#FB676D" />
      </linearGradient>
      <radialGradient
        id="paint1_radial_3184_16658"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(10.1202 10.707) scale(7.78964 9.47999)"
      >
        <stop offset="0.40427" stop-color="white" />
        <stop offset="0.46386" stop-color="white" stop-opacity="0.81865" />
        <stop offset="0.54312" stop-color="white" stop-opacity="0.60423" />
        <stop offset="0.62313" stop-color="white" stop-opacity="0.41926" />
        <stop offset="0.70214" stop-color="white" stop-opacity="0.26823" />
        <stop offset="0.77999" stop-color="white" stop-opacity="0.15091" />
        <stop offset="0.85632" stop-color="white" stop-opacity="0.06721" />
        <stop offset="0.93047" stop-color="white" stop-opacity="0.01694" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_3184_16658"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(9.97974 9.22941) scale(3.53358)"
      >
        <stop stop-color="#E6F4F5" />
        <stop offset="1" stop-color="#29BCEF" />
      </radialGradient>
      <radialGradient
        id="paint3_radial_3184_16658"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(10.1489 17.8205) scale(7.74772)"
      >
        <stop stop-color="#B2D5D7" />
        <stop offset="0.49406" stop-color="#29BCEF" />
        <stop offset="1" stop-color="#1B7CC2" />
      </radialGradient>
      <linearGradient
        id="paint4_linear_3184_16658"
        x1="10"
        y1="6.4247"
        x2="13.7377"
        y2="6.4247"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#1B5EC2" />
        <stop offset="0.14386" stop-color="#1C65C5" />
        <stop offset="0.36728" stop-color="#1F7BD0" />
        <stop offset="0.64076" stop-color="#249FE1" />
        <stop offset="0.82826" stop-color="#29BCEF" />
        <stop offset="1" stop-color="#7FCCE0" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_3184_16658"
        x1="11.7696"
        y1="7.61848"
        x2="10.8764"
        y2="11.2479"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#259AE5" />
        <stop offset="0.7207" stop-color="#05BEFF" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_3184_16658"
        x1="6.2627"
        y1="6.4247"
        x2="10.0004"
        y2="6.4247"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.02805" stop-color="#8EEBF0" />
        <stop offset="1" stop-color="#05BEFF" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_3184_16658"
        x1="11.79"
        y1="8.99941"
        x2="8.32284"
        y2="7.60339"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.02805" stop-color="#8EEBF0" />
        <stop offset="1" stop-color="#05BEFF" />
      </linearGradient>
    </defs>
  </svg>
);
export default LDO;
